import { Link } from "react-router-dom";
import { Flame, MapPin, Mail, Phone } from "lucide-react";import { useSite } from "@/context/SiteContext";
import { waLink, generalWaMessage, telLink } from "@/lib/whatsapp";

const Footer = () => {
  const site = useSite();
  return (
    <footer className="bg-secondary text-white/80 mt-auto" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-12 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2.5 mb-4">
              <img src="/logo.png" alt="Shrigokarnam logo" className="h-11 w-11 object-contain" />
              <span className="font-heading text-2xl font-semibold text-white">Shrigokarnam</span>
            </div>
            <p className="text-sm leading-relaxed text-white/70">
              {site.tagline || "Authentic priest-led poojas at the Gokarna Mahabaleshwar Temple."}
            </p>
          </div>

          <div>
            <h4 className="text-white font-heading text-xl mb-4">Explore</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/poojas" className="hover:text-gold transition-colors">All Poojas</Link></li>
              <li><Link to="/guidance" className="hover:text-gold transition-colors">Which Pooja is Right?</Link></li>
              <li><Link to="/temple-history" className="hover:text-gold transition-colors">Temple History</Link></li>
              <li><Link to="/blog" className="hover:text-gold transition-colors">Blog</Link></li>
              <li><Link to="/faq" className="hover:text-gold transition-colors">FAQ</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-heading text-xl mb-4">Contact</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex gap-2"><MapPin className="h-4 w-4 mt-0.5 shrink-0 text-gold" /><span>{site.address}</span></li>
              <li className="flex gap-2"><Mail className="h-4 w-4 mt-0.5 shrink-0 text-gold" /><a href={`mailto:${site.email}`} className="hover:text-gold">{site.email}</a></li>
              <li className="flex gap-2"><Phone className="h-4 w-4 mt-0.5 shrink-0 text-gold" /><a href={telLink(site.phone_number)} className="hover:text-gold">+{(site.phone_number || "").replace(/\D/g, "")}</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-heading text-xl mb-4">Book Now</h4>
            <p className="text-sm text-white/70 mb-4">Quick help on WhatsApp before you decide.</p>
            <a
              href={waLink(site.whatsapp_number, generalWaMessage)}
              target="_blank"
              rel="nofollow noopener noreferrer"
              data-testid="footer-whatsapp-button"
              className="inline-flex items-center gap-2 rounded-md bg-whatsapp px-5 py-3 text-sm font-semibold text-white hover:opacity-90"
            >
              <Phone className="h-4 w-4" /> Chat on WhatsApp
            </a>
          </div>
        </div>

        <div className="mt-12 border-t border-white/15 pt-6 flex flex-col sm:flex-row justify-between gap-3 text-xs text-white/50">
          <span>© {new Date().getFullYear()} Shrigokarnam. All rights reserved.</span>
          <span>Performed with devotion at Gokarna Mahabaleshwar Temple.</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
